import data from "./data";
import computed from "./computed";
import methods from "./methods";

import wordListMixin from "@/plugins/mixins/word-lists";

export default {
	name: "ResultTable",
	props: {
		fields: Array,
		words: Array,
		wordsMeta: Object,
		wordLength: Number,
		currentSort: String,
		tableHeaderText: String,
		// screenBottom: Number,
		// tableHeaderTextOverwrite: String,
		// enableMoreOptionsMenu: {
		// 	type: Boolean,
		// 	required: false,
		// 	default: true,
		// },
		// openUpwardCount: {
		// 	type: Number,
		// 	required: false,
		// 	default: 0,
		// },
		rowAds: {
			type: Array,
			required: false,
			default() {
				return [];
			},
		},
		loading: {
			type: Boolean,
			default: false,
		},
		// gameType: {
		// 	type: String,
		// 	required: false,
		// 	default: null,
		// },
		isAnagramsTable: {
			type: Boolean,
			default: false,
		},
		usePillsLayout: {
			type: Boolean,
			default: false,
		},
	},
	data,
	computed,
	mixins: [wordListMixin],
	methods,
	created() {
		if (this.isLengthPage) {
			this.itemsToShow = this.usePillsLayout ? 250 : 100;
		}
	},
	mounted() {
		this.tableRef = this.$refs.table;
	},
};
